export const WHATSAPP_NUMBER_DISPLAY = "07902 815281";
export const WHATSAPP_URL = "https://wa.me/447902815281";
export const INSTAGRAM_URL = "https://instagram.com/kieranwoolleymortgages";

export const waLink = (text) =>
  `${WHATSAPP_URL}?text=${encodeURIComponent(text)}`;

export const IMAGES = {
  hero: "/kieran-hero.jpg",
  advisor: "/kieran-headshot.jpg",
};

export const TESTIMONIALS = [
  {
    initials: "K",
    name: "Kayne",
    role: "Happy Client",
    quote:
      "Kieran is amazing! Excellent at what he does and very quick to respond when I had a question. Very helpful and knowledgeable! Thank you again!",
  },
  {
    initials: "K",
    name: "Kelly",
    role: "Home Mover",
    quote:
      "Kieran was friendly and professional and managed to secure us a mortgage offer extremely quickly. When we had a question about our house being of non-standard construction, he provided prompt advice. We will be recommending him to our family and friends. Thank you, Kieran!",
  },
  {
    initials: "S",
    name: "Sarah",
    role: "First-Time Buyer",
    quote:
      "10/10. Kieran was so helpful and knowledgeable. As a first time buyer there are lots of things you have no idea on when it comes to mortgages. I found him super reliable and he kept me informed every step of the way. I could even tell how pleased he was for me when my offer was accepted. A wonderfully nice man, would recommend to anyone.",
  },
];
